export default {
    concept({ price, quantity = 1, discount = 0, iva = 2, surcharge = 0 }) {
        let ctotal = 0
        let csubtotal = 0
        let cdiscount = 0
        let csurcharge = 0
        let civa = 0

        if (price && quantity) {
            csubtotal = price * quantity
            cdiscount = (csubtotal * discount) / 100
            csubtotal -= cdiscount

            if (surcharge) {
                csurcharge = (csubtotal * surcharge) / 100
            }

            if (iva) {
                civa = (csubtotal * iva) / 100
            }

            ctotal = csubtotal + csurcharge + civa
        }

        return {
            total: ctotal,
            subtotal: csubtotal,
            discount: {
                value: cdiscount,
                percent: discount,
            },
            surcharge: {
                value: csurcharge,
                percent: surcharge,
            },
            iva: {
                value: civa,
                percent: iva,
            },
        }
    },
    totals(concepts) {
        if (Object.keys(concepts).length > 0) {
            const calc = Object.keys(concepts).reduce((c, key) => {
                const discount = c.discount && c.discount.value ? c.discount.value : 0
                const discountPercent = c.discount && c.discount.percent ? c.discount.percent : 0

                const surcharge = c.surcharge && c.surcharge.value ? c.surcharge.value : 0
                const surchargePercent = c.surcharge && c.surcharge.percent ? c.surcharge.percent : 0

                const iva = c.iva && c.iva.value ? c.iva.value : 0
                const ivaPercent = c.iva && c.iva.percent ? c.iva.percent : 0

                return {
                    total: (c.total || 0) + concepts[key].total,
                    subtotal: (c.subtotal || 0) + concepts[key].subtotal,
                    discount: {
                        value: discount + concepts[key].discount.value,
                        percent: discountPercent + concepts[key].discount.percent,
                    },
                    iva: {
                        value: iva + concepts[key].iva.value,
                        percent: ivaPercent + concepts[key].iva.percent,
                    },
                    surcharge: {
                        value: surcharge + concepts[key].surcharge.value,
                        percent: surchargePercent + concepts[key].surcharge.percent,
                    },
                }
            }, 0)

            calc.subtotal = parseFloat(calc.subtotal.toFixed(2))
            calc.iva.value = parseFloat(calc.iva.value.toFixed(2))
            calc.surcharge.value = parseFloat(calc.surcharge.value.toFixed(2))
            calc.total = calc.subtotal + calc.iva.value + calc.surcharge.value

            calc.discount.percent = calc.discount.percent / Object.keys(concepts).length
            calc.surcharge.percent = calc.surcharge.percent / Object.keys(concepts).length
            calc.iva.percent = calc.iva.percent / Object.keys(concepts).length

            return calc
        } else {
            return {
                total: 0,
                subtotal: 0,
                discount: {
                    value: 0,
                    percent: 0,
                },
                iva: {
                    value: 0,
                    percent: 0,
                },
                surcharge: {
                    value: 0,
                    percent: 0,
                },
            }
        }
    },
}
